import React from 'react'
import { useState } from 'react';
import { useAddBookMutation } from '../features/api/apiSlice';
import { useNavigate } from 'react-router-dom';

export default function AddBook() {
    const [bookName, setBookName] = useState('');
    const [author, setAuthor] = useState('');
    const [thumbnail, setThumbnail] = useState('');
    const [price, setPrice] = useState('');
    const [rating, setRating] = useState('');
    const [featured, setFeatured] = useState(false);

    const [addBook, { isLoading }] = useAddBookMutation();
    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault();
        const bookData = {
            name: bookName,
            author,
            thumbnail,
            price,
            rating,
            featured,
        };
        addBook(bookData)
            .then(() => {
                // reset form after successful submission
                setBookName('');
                setAuthor('');
                setThumbnail('');
                setPrice('');
                setRating('');
                setFeatured(false);
                navigate("/");

            })
            .catch((err) => console.error(err));
    };
    return (
        <div class="container">
            <div class="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
                <h4 class="mb-8 text-xl font-bold text-center">Add New Book</h4>
                <form class="book-form" onSubmit={handleSubmit}>
                    <div class="space-y-2">
                        <label for="lws-bookName">Book Name</label>
                        <input required class="text-input" type="text" id="lws-bookName" name="name" value={bookName}
                            onChange={(e) => setBookName(e.target.value)} />
                    </div>

                    <div class="space-y-2">
                        <label for="lws-author">Author</label>
                        <input required class="text-input" type="text" id="lws-author" name="author" value={author}
                            onChange={(e) => setAuthor(e.target.value)} />
                    </div>

                    <div class="space-y-2">
                        <label for="lws-thumbnail">Image Url</label>
                        <input required class="text-input" type="text" id="lws-thumbnail" name="thumbnail" value={thumbnail}
                            onChange={(e) => setThumbnail(e.target.value)} />
                    </div>

                    <div class="grid grid-cols-2 gap-8 pb-4">
                        <div class="space-y-2">
                            <label for="lws-price">Price</label>
                            <input required class="text-input" type="number" id="lws-price" name="price" value={price}
                                onChange={(e) => setPrice(e.target.value)} />
                        </div>

                        <div class="space-y-2">
                            <label for="lws-rating">Rating</label>
                            <input required class="text-input" type="number" id="lws-rating" name="rating" min="1"
                                max="5" value={rating}
                                onChange={(e) => setRating(e.target.value)} />
                        </div>
                    </div>

                    <div class="flex items-center">
                        <input id="lws-featured" type="checkbox" name="featured" class="w-4 h-4" checked={featured} onChange={(e) => setFeatured(e.target.checked)} />
                        <label for="lws-featured" class="ml-2 text-sm"> This is a featured book </label>
                    </div>

                    <button type="submit" class="submit" id="lws-submit">Add Book</button>
                </form>
            </div>
        </div>
    )
}
